var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickNodeColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 32.5C23.3956 32.5 26.4749 31.146 28.7277 28.9486C28.7894 28.8883 28.8883 28.8883 28.9493 28.9493L34.1422 34.1421L39.532 39.5319C39.6486 39.6485 39.5285 39.8428 39.3721 39.7906L30.7705 36.9234C30.726 36.9086 30.6771 36.9146 30.6374 36.9396C27.5563 38.8784 23.9091 40 20 40C8.9543 40 0 31.0457 0 20C0 8.95427 8.9543 -3.05176e-05 20 -3.05176e-05C31.0457 -3.05176e-05 40 8.95427 40 20C40 24.7178 38.3665 29.054 35.6342 32.474C35.5764 32.5464 35.4686 32.5519 35.4031 32.4864L24.843 21.9263C24.7264 21.8097 24.8465 21.6154 25.0029 21.6676L31.7135 23.9045C31.7954 23.9317 31.884 23.8875 31.9102 23.8053C32.2933 22.6055 32.5 21.3269 32.5 20C32.5 13.0964 26.9036 7.49997 20 7.49997C13.0964 7.49997 7.5 13.0964 7.5 20C7.5 26.9035 13.0964 32.5 20 32.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickNodeColor);
export default __webpack_public_path__ + "static/media/quick-node-color.158c0d10213cb59612cc91215e604281.svg";
export { ForwardRef as ReactComponent };